export default __webpack_public_path__ + "static/media/mealandroid.6d4fcfbe.jpg";